import { useState } from "react";

export const faqs = [
  {
    q: "How fast can I get a passport in Montgomery, AL?",
    a: "Through Fast Passport Center, expedited processing can be as fast as 24 hours depending on your eligibility and the processing option you select. Standard government processing through the Montgomery Main Post Office can take 2–6 months, especially during busy military PCS seasons and summer travel peaks. For Maxwell AFB personnel with deployment orders, Alabama state officials with trade missions, and River Region families with upcoming cruises, that timeline simply does not work.",
  },
  {
    q: "Can Maxwell Air Force Base employees and military personnel get expedited passports?",
    a: "Absolutely. Maxwell AFB is one of the premier Air University campuses in the world, hosting the Air War College, Air Command and Staff College, and Squadron Officer School. These programs bring international officers from dozens of countries — and American officers frequently need passports on short notice for reciprocal visits, joint exercises, and PCS moves. We regularly process expedited renewals, new applications, and dependent passports for Maxwell AFB personnel on compressed timelines.",
  },
  {
    q: "Where is the Montgomery passport acceptance facility?",
    a: "The Montgomery Main Post Office at 135 Catoma St is the primary passport acceptance facility. Hours are Monday–Friday 9:00 AM–4:00 PM. The Prattville Post Office also accepts applications. However, these facilities only accept applications — they do not process expedited or emergency requests. For fast processing, you need a registered courier service.",
  },
  {
    q: "Can Alabama state government employees get expedited passports for trade missions?",
    a: "Yes. As the state capital, Montgomery hosts legislators, cabinet members, and agency officials who travel abroad for trade missions, international conferences, and bilateral meetings. These trips are sometimes arranged on short notice. We offer expedited processing with quick turnaround for government and business travel, and we understand the documentation requirements for official travel.",
  },
  {
    q: "Can Prattville, Wetumpka, and Millbrook residents use your services?",
    a: "Yes. All River Region communities including Prattville, Wetumpka, Millbrook, Elmore, Tallassee, and Pike Road are within our service area. Since we operate remotely, your physical location in the Montgomery metro area does not affect processing speed. Most clients receive their passports within 2–9 business days.",
  },
  {
    q: "What documents do I need for an expedited passport?",
    a: "Most applicants need: proof of U.S. citizenship (current or expired U.S. passport, birth certificate, or naturalization certificate), a government-issued photo ID, completed passport forms, and passport photos. Military personnel may have additional documentation pathways. We provide a personalized checklist after you start your order.",
  },
  {
    q: "Do I need to visit an office to use Fast Passport Center?",
    a: "No — most Montgomery travelers start online and ship their documents via overnight courier. There is no local Fast Passport Center office in Montgomery, but that is the point: you do not need one. Start your order online, follow the checklist, and ship your documents overnight from anywhere in the River Region.",
  },
  {
    q: "What do I need for a child passport in Montgomery?",
    a: "For minors under 16, both parents must appear with the child at an acceptance facility, or one parent with a notarized DS-3053 consent form. Bring proof of citizenship, a passport photo, and ID for both parents. This is the #1 cause of child passport delays for River Region families.",
  },
  {
    q: "Is Fast Passport Center an official government agency?",
    a: "No — Fast Passport Center is a private, approved and registered U.S. Department of State passport courier service. We are not a government agency. We work within the official passport system to provide expedited processing through reserved courier submission availability. As a registered courier, we offer rates typically 30–100% lower than FedEx, Staples, and other third-party resellers.",
  },
];

export default function MontgomeryFAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="bg-white py-20 md:py-28">
      <div className="max-w-3xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Questions?</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Frequently Asked <span className="text-[#F6C344]">Questions</span>
          </h2>
          <p className="text-gray-500 text-base">
            Everything Montgomery and River Region travelers ask us most often about expedited passport services.
          </p>
        </div>

        <div className="space-y-2">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className="bg-[#F7F8FA] rounded-lg border border-gray-200 overflow-hidden"
            >
              <button
                className="w-full flex items-center justify-between gap-4 p-5 text-left cursor-pointer"
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
              >
                <span className="font-semibold text-[#1A365D] text-sm leading-snug">{faq.q}</span>
                <div className="w-7 h-7 flex items-center justify-center rounded-full bg-[#1A365D] flex-shrink-0">
                  <i
                    className={`text-white text-sm transition-transform duration-200 ${
                      openIndex === i ? "ri-subtract-line" : "ri-add-line"
                    }`}
                  ></i>
                </div>
              </button>
              {openIndex === i && (
                <div className="px-5 pb-5">
                  <p className="text-gray-500 text-sm leading-relaxed border-t border-gray-200 pt-4">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <p className="text-gray-500 text-sm mb-4">Still have questions? Our team is here to help.</p>
          <a
            href="tel:8772530084"
            className="inline-flex items-center gap-2 bg-[#1A365D] hover:bg-[#0F2240] text-white font-semibold text-sm px-6 py-3 rounded-md transition-all whitespace-nowrap"
          >
            <i className="ri-phone-line"></i> Call 877-253-0084
          </a>
        </div>
      </div>
    </section>
  );
}